/* RESPONSIBLE TEAM: team-proactive-support */
import { belongsTo } from '@ember-data/model';
import RulesetLink from '../ruleset-link';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import type NewsfeedModel from 'embercom/models/news/newsfeed';

export default class extends RulesetLink {
  @belongsTo('news/newsfeed', { async: false }) declare object: NewsfeedModel;
  objectType = objectTypes.newsfeed;
}
